import HeroPriceActionBootcamp from "./HeroPriceActionBootcamp";
import TpcBootcampOnlineDelivery from "./TpcBootcampOnlineDelivery";
import TpcCurriculumExplorer from "./TpcCurriculumExplorer";
import BootcampSuccessSection from "./BootcampSuccessSection";
import BootcampPerformanceOutcomes from "./BootcampPerformanceOutcomes";
import BootcampTraderAdvantage from "./BootcampTraderAdvantage";
import BootcampStudyMode from "./BootcampStudyMode";
import TradePerformanceCentreNextStep from "./TradePerformanceCentreNextStep";
import TpcPriceActionTraderProductCard from "../homePage/TpcPriceActionTraderProductCard";

function PriceActionBootcamp() {
  return (
    <article className="trpc-price-action-page">
      <HeroPriceActionBootcamp />
      <BootcampSuccessSection />
      <BootcampPerformanceOutcomes />
      <TpcCurriculumExplorer />
      {/* <BootcampTraderAdvantage /> */}
      {/* <TpcBootcampOnlineDelivery /> */}
      <BootcampStudyMode />
      {/* <TpcPriceActionTraderProductCard /> */}
      <TradePerformanceCentreNextStep />
    </article>
  );
}

export default PriceActionBootcamp;